/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneErrorPage as ResolvedStandaloneErrorPage } from 'base/components/standalone/ErrorPage';

export const ErrorPage: typeof ResolvedStandaloneErrorPage = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneErrorPage {...props} />
    );
});

export type ErrorPageProps = PropsFromComponent<typeof ErrorPage>;

/** @deprecated Use slot architecture instead */
export const ErrorPageWith = (extras: DynamicStandaloneExtras): typeof ErrorPage => {
    return function ErrorPage(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ErrorPage');
        return <ResolvedStandaloneErrorPage {...mergeProps({ options: { theme } }, props)} />;
    }
}